import { useAtomValue } from 'jotai'
import React from 'react'
import * as R from 'remeda'

import { surveyGroupFilterAtom } from '~/atoms'
import { useCurrentSurveyGroup } from '~/hooks/useCurrentSurveyGroup'

/**
 * サーベイIDとサンプルサイズのマップを返すカスタムフックです。
 *
 * @returns サーベイIDとサンプルサイズのマップ。
 */
export const useSurveyIdSampleSizeMap = () => {
  const surveyGroup = useCurrentSurveyGroup()
  const surveyGroupFilter = useAtomValue(surveyGroupFilterAtom)

  return React.useMemo(
    () =>
      R.mapToObj(surveyGroup?.surveys ?? [], (survey) => [
        survey.id,
        surveyGroupFilter?.countMap?.[survey.id] ??
          survey.numberOfTotalAnswers ??
          undefined,
      ]),
    [surveyGroup?.surveys, surveyGroupFilter?.countMap],
  )
}
